/* eslint-disable */

export class UOM {

    uomId: number | undefined;
    name: string | undefined;
    shortName: string | undefined;
    description: string | undefined;
    factor: number | undefined;

}